import React from "react";
import { Typography } from "@mui/material";

import "./index.scss";

interface DividerProps {
  text?: string;
}

const Divider: React.FC<DividerProps> = ({ text }) => {
  return (
    <div className="divider">
      <div className="leftDashes" />
      {text && (
        <>
          <Typography
            sx={{ mx: 1.5, whiteSpace: "nowrap" }}
            variant="subtitle2"
            color="textSecondary"
          >
            {text}
          </Typography>

          <div className="rightDashes" />
        </>
      )}
    </div>
  );
};

export default Divider;
